import pkg from '../../package.json'

/**
 * Config composable
 */
export function useConfig() {

  //Expose merged config
  return {
    app: {
      version: pkg.version,
      identifier: pkg.name,
      name: import.meta.env.VITE_APP_NAME,
    },
  }
}
